(function () {
  'use strict';

  if (window.PrimeShopperNeoSolutions) {
    window.PrimeShopperNeoSolutions.init(document);
    return;
  }
  var instances = new Map();
  var lightbox;
  var backdrop;
  var trigger;
  var previousOverflow = '';
  var lightboxOpen = false;

  function createLightbox() {
    if (lightbox) return;
    lightbox = document.createElement('dialog');
    lightbox.className = 'neo-image-lightbox';
    lightbox.setAttribute('role', 'dialog');
    lightbox.setAttribute('aria-labelledby', 'NeoImageLightboxTitle');
    lightbox.setAttribute('aria-modal', 'true');
    lightbox.innerHTML = '<div class="neo-image-lightbox__header"><h2 class="neo-image-lightbox__title" id="NeoImageLightboxTitle"></h2><div class="neo-image-lightbox__actions"><button type="button" data-neo-image-size aria-pressed="false">拡大する</button><button type="button" data-neo-image-close aria-label="拡大画面を閉じる">閉じる ×</button></div></div><div class="neo-image-lightbox__surface" tabindex="0" role="region" aria-label="画面イメージ。拡大後は上下左右にスクロールできます"><img class="neo-image-lightbox__image" alt=""></div><p class="neo-image-lightbox__hint">拡大すると、画面を上下左右にスクロールできます。</p>';
    backdrop = document.createElement('div');
    backdrop.className = 'neo-image-lightbox-backdrop';
    backdrop.hidden = true;
    document.body.append(backdrop, lightbox);
    lightbox.querySelector('[data-neo-image-close]').addEventListener('click', closeLightbox);
    backdrop.addEventListener('click', closeLightbox);
    lightbox.addEventListener('click', function (event) {
      if (event.target !== lightbox) return;
      var bounds = lightbox.getBoundingClientRect();
      if (event.clientX < bounds.left || event.clientX > bounds.right || event.clientY < bounds.top || event.clientY > bounds.bottom) closeLightbox();
    });
    lightbox.addEventListener('cancel', function (event) {
      event.preventDefault();
      closeLightbox();
    });
    lightbox.addEventListener('close', restoreFocus);
    lightbox.querySelector('[data-neo-image-size]').addEventListener('click', function () {
      var expanded = lightbox.getAttribute('data-neo-image-fit') === 'false';
      lightbox.setAttribute('data-neo-image-fit', expanded ? 'true' : 'false');
      this.setAttribute('aria-pressed', String(!expanded));
      this.textContent = expanded ? '拡大する' : '全体を見る';
      var surface = lightbox.querySelector('.neo-image-lightbox__surface');
      surface.scrollTop = 0;
      surface.scrollLeft = 0;
    });
    document.addEventListener('keydown', function (event) {
      if (!lightboxOpen) return;
      if (event.key === 'Escape') {
        event.preventDefault();
        closeLightbox();
        return;
      }
      if (event.key !== 'Tab') return;
      var focusable = lightbox.querySelectorAll('button, [tabindex="0"]');
      var first = focusable[0];
      var last = focusable[focusable.length - 1];
      if (event.shiftKey && (document.activeElement === first || !lightbox.contains(document.activeElement))) {
        event.preventDefault();
        last.focus();
      } else if (!event.shiftKey && (document.activeElement === last || !lightbox.contains(document.activeElement))) {
        event.preventDefault();
        first.focus();
      }
    }, true);
    document.addEventListener('focusin', function (event) {
      if (lightboxOpen && !lightbox.contains(event.target)) lightbox.querySelector('[data-neo-image-close]').focus();
    });
  }

  function restoreFocus() {
    if (!lightboxOpen) return;
    lightboxOpen = false;
    backdrop.hidden = true;
    lightbox.classList.remove('is-fallback');
    document.body.style.overflow = previousOverflow;
    if (trigger && trigger.isConnected) trigger.focus({ preventScroll: true });
    trigger = null;
  }

  function closeLightbox() {
    if (!lightbox || !lightboxOpen) return;
    if (typeof lightbox.close === 'function') lightbox.close();
    else lightbox.removeAttribute('open');
    restoreFocus();
  }

  function openLightbox(anchor) {
    createLightbox();
    trigger = anchor;
    var sourceImage = anchor.querySelector('img');
    var title = anchor.getAttribute('data-neo-zoom-title') || (sourceImage && sourceImage.alt) || 'NEOの画面イメージ';
    lightbox.querySelector('.neo-image-lightbox__title').textContent = title;
    var largeImage = lightbox.querySelector('img');
    largeImage.src = anchor.href;
    largeImage.alt = title;
    lightbox.setAttribute('data-neo-image-fit', 'true');
    var sizeButton = lightbox.querySelector('[data-neo-image-size]');
    sizeButton.setAttribute('aria-pressed', 'false');
    sizeButton.textContent = '拡大する';
    previousOverflow = document.body.style.overflow;
    document.body.style.overflow = 'hidden';
    lightboxOpen = true;
    try {
      if (typeof lightbox.showModal !== 'function') throw new Error('Dialog fallback');
      lightbox.showModal();
    } catch (_) {
      lightbox.setAttribute('open', '');
      lightbox.classList.add('is-fallback');
      backdrop.hidden = false;
    }
    var surface = lightbox.querySelector('.neo-image-lightbox__surface');
    surface.scrollTop = 0;
    surface.scrollLeft = 0;
    lightbox.querySelector('[data-neo-image-close]').focus({ preventScroll: true });
  }

  function setup(root) {
    if (instances.has(root)) return;
    var nav = root.querySelector('[data-neo-tabs]');
    var tabs = Array.from(root.querySelectorAll('[data-neo-tab]'));
    var panels = Array.from(root.querySelectorAll('[data-neo-panel]'));
    if (!nav || !tabs.length || tabs.length !== panels.length) return;
    function activate(index, focus) {
      tabs.forEach(function (tab, i) {
        var selected = i === index;
        tab.setAttribute('aria-selected', String(selected));
        tab.tabIndex = selected ? 0 : -1;
        panels[i].hidden = !selected;
      });
      if (focus) tabs[index].focus();
    }
    function clickTab(event) {
      var tab = event.target.closest('[data-neo-tab]');
      if (!tab || !nav.contains(tab)) return;
      activate(tabs.indexOf(tab), false);
    }
    function keyboardTab(event) {
      var index = tabs.indexOf(event.target);
      if (index < 0) return;
      var next = index;
      if (event.key === 'ArrowRight') next = (index + 1) % tabs.length;
      else if (event.key === 'ArrowLeft') next = (index - 1 + tabs.length) % tabs.length;
      else if (event.key === 'Home') next = 0;
      else if (event.key === 'End') next = tabs.length - 1;
      else return;
      event.preventDefault();
      activate(next, true);
    }
    function selectBlock(event) {
      var blockId = event.detail && event.detail.blockId;
      var index = tabs.findIndex(function (tab) { return tab.getAttribute('data-neo-tab') === blockId; });
      if (index >= 0) activate(index, false);
    }
    nav.setAttribute('role', 'tablist');
    tabs.forEach(function (tab) { tab.setAttribute('role', 'tab'); });
    panels.forEach(function (panel, i) {
      panel.setAttribute('role', 'tabpanel');
      panel.setAttribute('aria-labelledby', tabs[i].id);
      panel.tabIndex = 0;
    });
    activate(0, false);
    root.setAttribute('data-neo-enhanced', '');
    nav.hidden = false;
    nav.addEventListener('click', clickTab);
    nav.addEventListener('keydown', keyboardTab);
    document.addEventListener('shopify:block:select', selectBlock);
    instances.set(root, function () {
      nav.removeEventListener('click', clickTab);
      nav.removeEventListener('keydown', keyboardTab);
      document.removeEventListener('shopify:block:select', selectBlock);
      panels.forEach(function (panel) { panel.hidden = false; });
      if (trigger && root.contains(trigger)) closeLightbox();
      instances.delete(root);
    });
  }

  function init(scope) {
    if (scope.matches && scope.matches('[data-neo-showcase]')) setup(scope);
    scope.querySelectorAll('[data-neo-showcase]').forEach(setup);
  }
  document.addEventListener('click', function (event) {
    var anchor = event.target.closest && event.target.closest('a[data-neo-zoom]');
    if (!anchor || event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    event.preventDefault();
    openLightbox(anchor);
  });
  document.addEventListener('shopify:section:load', function (event) { init(event.target); });
  document.addEventListener('shopify:section:unload', function (event) {
    instances.forEach(function (cleanup, root) {
      if (event.target === root || event.target.contains(root)) cleanup();
    });
  });
  window.PrimeShopperNeoSolutions = { init: init };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(document); }, { once: true });
  else init(document);
}());
